import { withInstall } from '@pit-element-plus/utils'
import PageHeader from './src/page-header.vue'

import type { SFCWithInstall } from '@pit-element-plus/utils'

export const ElPageHeader: SFCWithInstall<typeof PageHeader> =
  withInstall(PageHeader)
export default ElPageHeader

export * from './src/page-header'
